import React, { Component } from "react";
import Slider from "react-slick";
import Image from '../global/Image';
import { Link } from 'react-router-dom';

export default class Gallery extends Component {
	
	constructor(props) {
    	super(props);
    	this.state = {
			index : 0,
			open : 	false,
			location: '',
			transitionClass: ''
		}
		this.showNextCursor = this.showNextCursor.bind(this);
		this.hideNextCursor = this.hideNextCursor.bind(this);
		this.showPrevCursor = this.showPrevCursor.bind(this);
		this.hidePrevCursor = this.hidePrevCursor.bind(this);
    }
    
	showNextCursor() {
		document.documentElement.classList.add('state-next-hover');
	}
	
	hideNextCursor() {
		document.documentElement.classList.remove('state-next-hover');
	}
	
	showPrevCursor() {
		document.documentElement.classList.add('state-prev-hover');
	}
	
	hidePrevCursor() {
		document.documentElement.classList.remove('state-prev-hover');
	}
    	
	componentDidMount() {
		setTimeout(() => {
			if (window.document.getElementsByClassName('slick-prev').length > 0) {
				window.document.getElementsByClassName('slick-prev')[0].addEventListener('mousemove', function(){
					if (!window.document.getElementsByClassName('slick-prev')[0].classList.contains('slick-disabled')) {
						document.documentElement.classList.add('state-prev-hover');
					} else {
						document.documentElement.classList.remove('state-prev-hover');
					}
				});
				window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseenter', function(){
					if (!window.document.getElementsByClassName('slick-prev')[0].classList.contains('slick-disabled')) {
						document.documentElement.classList.add('state-prev-hover');
					} else {
						document.documentElement.classList.remove('state-prev-hover');
					}
				});
				window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseleave', function(){
					document.documentElement.classList.remove('state-prev-hover');
				});
				window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseenter', function(){
					if (!window.document.getElementsByClassName('slick-next')[0].classList.contains('slick-disabled')) {
						document.documentElement.classList.add('state-next-hover');
					} else {
						document.documentElement.classList.remove('state-next-hover');
					}
				});
				window.document.getElementsByClassName('slick-next')[0].addEventListener('mousemove', function(){
					if (!window.document.getElementsByClassName('slick-next')[0].classList.contains('slick-disabled')) {
						document.documentElement.classList.add('state-next-hover');
					} else {
						document.documentElement.classList.remove('state-next-hover');
					}
				});
				window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseleave', function(){
					document.documentElement.classList.remove('state-next-hover');
				});
			}
		}, 500);
		this.setState({
			location: window.location + '',
			index: 0
		});
	}
	
	componentDidUpdate() {
		if (window.location + '' !== this.state.location) {
			this.setState({
				location: window.location + '',
				transitionClass:'state-no-transition'
			});
			setTimeout(() => {
				if (this.slider) {
					this.slider.slickGoTo(0);
				}
				setTimeout(() => {
					this.setState({
						transitionClass:''
					});
				}, 100);
			}, 500);
		}
	}
  			
	render() {
		
		let gallery = this.props.gallery;
		
		if (gallery) {
	    	const settings = {
				dots: 			false,
				arrows: 		true,
				infinite: 		false,
				speed: 			0,
				slidesToScroll: 1,
				centerMode: 	false,
				variableWidth: 	false,
				beforeChange: 	(current, next) => this.setState({ index:next })
			};

			return (				
				
				<>
					<div className={'c-project__gallery scope-slick scope-slick--' + gallery.length + ' ' + this.state.transitionClass}>
						<Slider ref={slider => (this.slider = slider)} {...settings}>
							{gallery.map((slide,i) =>
								{
									return (
										<div className={'inner ' + slide.fitting} key={i}>							
											<Image width={slide.width} height={slide.height} srcset={slide.srcset} src={slide.src} />
										</div>
									)
								}
							)}
						</Slider>
						{this.state.index === (gallery.length - 1) && this.props.next_url &&
							<Link className="c-project__gallery__next-url" to={{ pathname: this.props.next_url }} onMouseOver={this.showNextCursor} onMouseOut={this.hideNextCursor}></Link>
						}
						{this.state.index === 0 && this.props.prev_url &&
							<Link className="c-project__gallery__prev-url" to={{ pathname: this.props.prev_url }} onMouseOver={this.showPrevCursor} onMouseOut={this.hidePrevCursor}></Link>
						}
					</div>
					<p className="c-project__gallery__counter" dangerouslySetInnerHTML={{__html:(this.state.index + 1) + '/' + gallery.length}}></p>
					<div className="c-project__paginaton">
						{this.props.next_url &&
							<Link className="c-project__paginaton__button" to={{ pathname: this.props.next_url }} dangerouslySetInnerHTML={{__html:'< Prev'}}></Link>
						}
						{this.props.prev_url &&
							<Link className="c-project__paginaton__button" to={{ pathname: this.props.prev_url }} dangerouslySetInnerHTML={{__html:'Next >'}}></Link>
						}
					</div>				
				</>					
			);
			
		} else {
			return null;
		}
	}
}